import logo from './logo.svg';
import './App.css';
import ImgPre from './Components/ImgPre';

function App() {


  return (
    <div className="App">
     <ImgPre></ImgPre>
    </div>
  );
}

export default App;
